import { Stack } from "@mui/material";
import { round } from "src/utils/value-formatter";
import React from "react";
import styled from "styled-components";

const SubTitle = styled.p`
    font-size: 11px;
    font-weight: 200;
    margin: 0;
    line-height: 1;
    margin-bottom: 26px;
`;
const calculateLastWeekDifference = (metric) => {
    let difference;
    const isPercentile = metric.type === "percentile" ? "%" : "";
    if (metric.type === "interval") {
        return <SubTitle>{metric.baseline} on average</SubTitle>;
    }
    if (metric.value > metric.baseline) {
        difference = metric.value - metric.baseline;
        return (
            <Stack direction="row" spacing={0.5}>
                {Number.isInteger(difference) ? (
                    <SubTitle style={{ color: "lightgreen", fontWeight: "300" }}>
                        {round(difference, 0)}
                        {isPercentile} more
                    </SubTitle>
                ) : (
                    <SubTitle style={{ color: "lightgreen", fontWeight: "300" }}>
                        {round(difference, 2)}
                        {isPercentile} more
                    </SubTitle>
                )}
                <SubTitle>than your average</SubTitle>
            </Stack>
        );
    }
    if (metric.value < metric.baseline) {
        difference = metric.baseline - metric.value;
        return (
            <Stack direction="row" spacing={0.5}>
                {Number.isInteger(difference) ? (
                    <SubTitle style={{ color: "orange", fontWeight: "300" }}>
                        {round(difference, 0)}
                        {isPercentile} less
                    </SubTitle>
                ) : (
                    <SubTitle style={{ color: "orange", fontWeight: "300" }}>
                        {round(difference, 1)}
                        {isPercentile} less
                    </SubTitle>
                )}
                <SubTitle>than your average</SubTitle>
            </Stack>
        );
    }
    if (metric.value === metric.baseline) {
        return <SubTitle>Same as your average</SubTitle>;
    }
    return null;
};

export default calculateLastWeekDifference;
